var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHero2 = function SvgHero2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.815 61.014"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M54.995 60.515v-49h10.32v49Zm-17.816 0V21.474h10.32v39.041Zm-17.816 0V31.433h10.32v29.082Zm-17.816 0V41.396h10.318v19.119Zm-.91-27.17a1.044 1.044 0 0 1 .4-1.419L50.423 4.315l-1.262-2.246A1.043 1.043 0 0 1 50.354.555l4.926 1.4a1.037 1.037 0 0 1 .717 1.283l-1.391 4.925a1.04 1.04 0 0 1-.881.755 1 1 0 0 1-.121 0 1.05 1.05 0 0 1-.91-.533l-1.26-2.25L2.055 33.743a1.04 1.04 0 0 1-1.42-.4Zm52.65-28.173.426-1.5-1.506-.425Z"
  })));
};
export default SvgHero2;